var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgVideocalls = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 29.785,
      height: 18.666,
      viewBox: "0 0 29.785 18.666",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_17015",
      "data-name": "Group 17015",
      transform: "translate(-3063.906 5204.521)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_21982",
      "data-name": "Path 21982",
      d: "M3179-5187.072v5.351a1.352,1.352,0,0,0,.6,1.111l3.743,2.573a1.638,1.638,0,0,0,2.59-1.247v-10.229a1.638,1.638,0,0,0-2.59-1.247l-3.743,2.573A1.353,1.353,0,0,0,3179-5187.072Z",
      transform: "translate(-92.24 -10.792)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_21983",
      "data-name": "Path 21983",
      d: "M3080.368-5204.522h-12.85a3.612,3.612,0,0,0-3.611,3.612v11.441a3.612,3.612,0,0,0,3.611,3.612h12.85a3.612,3.612,0,0,0,3.612-3.612v-11.441A3.612,3.612,0,0,0,3080.368-5204.522Zm-2.383,10.229-6.476,3.738a.952.952,0,0,1-1.428-.824v-7.477a.952.952,0,0,1,1.428-.826l6.476,3.739A.953.953,0,0,1,3077.985-5194.293Z",
      transform: "translate(0)"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgVideocalls, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Videocalls.8e560d10.svg";
export { ForwardRef as ReactComponent };